import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'usb-product-media',
  templateUrl: './product-media.component.html',
  styleUrls: ['./product-media.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductMediaComponent implements OnInit {

  @Input() imageUrl;
  @Input() logoUrl;
  @Input() categoryId;
  @Input() mealsData;
  @Input() mealsNameRoom;
  @Input() rentalCarData;
  @Input() supplierLogo;
  @Input() clientsSettingAppBooking;
  @Input() exclusiveDeal;
  @Input() stylePathPrice;
  @Input() blickoins;
  @Output() imageClick = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

   openModal(): void {
    this.imageClick.emit();
  }


}
